import { useLanguage } from "../i18n/LanguageContext";
import { Button } from "../components/ui/button";

function formatDate(date, lang) {
  return date.toLocaleDateString(lang === "nl" ? "nl-NL" : "en-GB", { weekday: "long", year: "numeric", month: "long", day: "numeric" });
}

export const SummaryStep = ({ service, date, time, formData, onConfirm, submitting, error }) => {
  const { t, lang } = useLanguage();

  return (
    <div data-testid="booking-summary-step">
      <h2 className="font-serif text-2xl text-white mb-6">{t("booking.summary.title")}</h2>
      <div className="bg-[#141414] border border-white/10 rounded-xl p-6 max-w-md space-y-3">
        <Row label={t("booking.summary.service")} value={lang === "nl" ? service.name_nl : service.name_en} />
        <Row label={t("booking.summary.date")} value={formatDate(date, lang)} />
        <Row label={t("booking.summary.time")} value={time} />
        <Row label={t("booking.summary.duration")} value={`${service.duration} ${t("services.minutesLabel")}`} />
        <Row label={t("booking.summary.price")} value={`€${service.price % 1 === 0 ? service.price.toFixed(0) : service.price}`} highlight />
        <div className="border-t border-white/10 pt-3 mt-3">
          <Row label={t("booking.summary.customer")} value={formData.customer_name} />
          <Row label={t("booking.summary.email")} value={formData.customer_email} />
          <Row label={t("booking.summary.phone")} value={formData.customer_phone} />
        </div>
      </div>

      {error && <p data-testid="booking-summary-error" className="text-red-400 text-sm mt-4 max-w-md">{error}</p>}

      <Button
        data-testid="booking-confirm-button"
        onClick={onConfirm}
        disabled={submitting}
        className="mt-6 bg-gold text-white hover:bg-gold-hover rounded-none px-8 py-6 disabled:opacity-60"
      >
        {submitting ? t("booking.confirming") : t("booking.confirmButton")}
      </Button>
    </div>
  );
};

const Row = ({ label, value, highlight }) => (
  <div className="flex items-center justify-between text-sm">
    <span className="text-white/50">{label}</span>
    <span className={highlight ? "text-gold font-serif text-lg" : "text-white"}>{value}</span>
  </div>
);
